import styled from 'styled-components';
import { device } from '@/styles/helpers';

export const ScEmptyState = styled.div`
  display: flex;
  padding: 32px 16px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  border-radius: 16px;
  background: #1c1c1e;

  & .title {
    color: ${({ theme }) => theme.whiteColor};
    text-align: center;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0;
    text-transform: uppercase;
    margin-bottom: 8px;
  }

  & .description {
    color: #8e8e93;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0;
    margin-bottom: 16px;
    text-align: center;
  }

  & .promo-hint {
    color: ${({ theme }) => theme.whiteColor};
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0px;
    text-transform: uppercase;
    margin: 32px 0 16px;
  }

  & .links {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 32px;

    & button,
    & a {
      color: #25aad6;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 28px;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
      background: none;
      border: none;
      cursor: pointer;
    }
  }

  & .btn-explore-offers-container {
    max-width: 180px;
    width: 100%;
  }

  @media (${device.mobile}) {
    & .title {
      font-size: 16px;
      line-height: 20px;
    }

    & .description {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }

    & .promo-hint {
      font-size: 14px;
      line-height: 18px;
    }

    & .links {
      flex-direction: column;
      align-items: center;
      gap: 16px;
    }
  }
`;
